<template>
  <div class="handleLog">
    <!-- 面包屑导航 -->
    <crumbs-bar  @refresh="handleRefresh" :crumbsList="['日志管理', $route.meta.title]"> </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          style="width:200px;margin-right:5px;"
          v-model="searchForm.start"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          placeholder="开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          clearable
          v-model="searchForm.end"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width:200px;margin-right:5px;"
          placeholder="截至日期"
        >
        </el-date-picker>
        <el-input
          style="width:200px;margin-right:5px"
          clearable
          placeholder="输入管理员名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="name"
        label="管理员"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Request"
        label="IP地址"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="AddTime"
        label="操作时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="KeyId"
        label="操作数据"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Operation"
        label="操作类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="flag"
        label="操作结果"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Remark"
        label="备注"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "handleLog",
  data() {
    return {
      /**表格数据 */
      //编号	时间	管理员账号	操作说明
      tableData: [
        {
          number: "编号",
          time: "时间",
          admin: "管理员账号",
          des: "操作说明",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        start: "",
        end: "",
        name: "",
      },
    };
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Pc_GetAdminLogList",
        mindate: this.searchForm.start,
        maxdate: this.searchForm.end,
        username: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Pc_Log"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "function/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
      console.log('alalal');
    },
  },
};
</script>

<style scoped>
.handleLog {
  width: 100%;
  height: 100%;
}
</style>
